"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const static_colors_1 = __importDefault(require("../../global/static-colors"));
const spacing_1 = __importDefault(require("./spacing"));
const typography_1 = __importDefault(require("./typography"));
const output = {
    name: 'domain-dark',
    spacing: spacing_1.default,
    typography: typography_1.default,
    colors: {
        neutral: {
            heavy: {
                default: static_colors_1.default.coolGrey50,
                hover: static_colors_1.default.coolGrey50,
                pressed: static_colors_1.default.coolGrey50,
                selected: static_colors_1.default.coolGrey50,
                disabled: static_colors_1.default.coolGrey50,
            },
            medium: {
                default: static_colors_1.default.coolGrey300,
                hover: static_colors_1.default.coolGrey300,
                pressed: static_colors_1.default.coolGrey300,
                selected: static_colors_1.default.coolGrey300,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.coolGrey500,
                hover: static_colors_1.default.coolGrey600,
                pressed: static_colors_1.default.coolGrey700,
                selected: static_colors_1.default.coolGrey900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.coolGrey700,
                hover: static_colors_1.default.coolGrey700,
                pressed: static_colors_1.default.coolGrey700,
                selected: static_colors_1.default.coolGrey700,
                disabled: static_colors_1.default.coolGrey700,
            },
            subdued: {
                default: static_colors_1.default.coolGrey900,
                hover: static_colors_1.default.coolGrey900,
                pressed: static_colors_1.default.coolGrey900,
                selected: static_colors_1.default.coolGrey900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.coolGrey800,
                hover: static_colors_1.default.coolGrey800,
                pressed: static_colors_1.default.coolGrey800,
                selected: static_colors_1.default.coolGrey800,
                disabled: static_colors_1.default.coolGrey800,
            },
        },
        interactive: {
            heavy: {
                default: static_colors_1.default.domainGreen100,
                hover: static_colors_1.default.domainGreen50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.domainGreen300,
                hover: static_colors_1.default.domainGreen200,
                pressed: static_colors_1.default.domainGreen100,
                selected: static_colors_1.default.domainGreen100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.domainGreen400,
                hover: static_colors_1.default.domainGreen300,
                pressed: static_colors_1.default.domainGreen200,
                selected: static_colors_1.default.domainGreen200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.domainGreen700,
                hover: static_colors_1.default.domainGreen600,
                pressed: static_colors_1.default.domainGreen500,
                selected: static_colors_1.default.domainGreen500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.domainGreen900,
                hover: static_colors_1.default.domainGreen900,
                pressed: static_colors_1.default.domainGreen900,
                selected: static_colors_1.default.domainGreen900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.domainGreen800,
                hover: static_colors_1.default.domainGreen700,
                pressed: static_colors_1.default.domainGreen600,
                selected: static_colors_1.default.domainGreen600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        primary: {
            heavy: {
                default: static_colors_1.default.domainGreen100,
                hover: static_colors_1.default.domainGreen50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.domainGreen300,
                hover: static_colors_1.default.domainGreen200,
                pressed: static_colors_1.default.domainGreen100,
                selected: static_colors_1.default.domainGreen100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.domainGreen400,
                hover: static_colors_1.default.domainGreen300,
                pressed: static_colors_1.default.domainGreen200,
                selected: static_colors_1.default.domainGreen200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.domainGreen700,
                hover: static_colors_1.default.domainGreen600,
                pressed: static_colors_1.default.domainGreen500,
                selected: static_colors_1.default.domainGreen500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.domainGreen900,
                hover: static_colors_1.default.domainGreen900,
                pressed: static_colors_1.default.domainGreen900,
                selected: static_colors_1.default.domainGreen900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.domainGreen800,
                hover: static_colors_1.default.domainGreen700,
                pressed: static_colors_1.default.domainGreen600,
                selected: static_colors_1.default.domainGreen600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        secondary: {
            heavy: {
                default: static_colors_1.default.domainBlue100,
                hover: static_colors_1.default.domainBlue50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.domainBlue300,
                hover: static_colors_1.default.domainBlue200,
                pressed: static_colors_1.default.domainBlue100,
                selected: static_colors_1.default.domainBlue100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.domainBlue400,
                hover: static_colors_1.default.domainBlue300,
                pressed: static_colors_1.default.domainBlue200,
                selected: static_colors_1.default.domainBlue200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.domainBlue700,
                hover: static_colors_1.default.domainBlue600,
                pressed: static_colors_1.default.domainBlue500,
                selected: static_colors_1.default.domainBlue500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.domainBlue900,
                hover: static_colors_1.default.domainBlue900,
                pressed: static_colors_1.default.domainBlue900,
                selected: static_colors_1.default.domainBlue900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.domainBlue800,
                hover: static_colors_1.default.domainBlue700,
                pressed: static_colors_1.default.domainBlue600,
                selected: static_colors_1.default.domainBlue600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        info: {
            heavy: {
                default: static_colors_1.default.ocean100,
                hover: static_colors_1.default.ocean50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.ocean300,
                hover: static_colors_1.default.ocean200,
                pressed: static_colors_1.default.ocean100,
                selected: static_colors_1.default.ocean100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.ocean400,
                hover: static_colors_1.default.ocean300,
                pressed: static_colors_1.default.ocean200,
                selected: static_colors_1.default.ocean200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.ocean700,
                hover: static_colors_1.default.ocean600,
                pressed: static_colors_1.default.ocean500,
                selected: static_colors_1.default.ocean500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.ocean900,
                hover: static_colors_1.default.ocean900,
                pressed: static_colors_1.default.ocean900,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.ocean800,
                hover: static_colors_1.default.ocean700,
                pressed: static_colors_1.default.ocean600,
                selected: static_colors_1.default.ocean600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        success: {
            heavy: {
                default: static_colors_1.default.domainGreen100,
                hover: static_colors_1.default.domainGreen50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.domainGreen300,
                hover: static_colors_1.default.domainGreen200,
                pressed: static_colors_1.default.domainGreen100,
                selected: static_colors_1.default.domainGreen100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.domainGreen400,
                hover: static_colors_1.default.domainGreen300,
                pressed: static_colors_1.default.domainGreen200,
                selected: static_colors_1.default.domainGreen200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.domainGreen700,
                hover: static_colors_1.default.domainGreen600,
                pressed: static_colors_1.default.domainGreen500,
                selected: static_colors_1.default.domainGreen500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.domainGreen900,
                hover: static_colors_1.default.domainGreen900,
                pressed: static_colors_1.default.domainGreen900,
                selected: static_colors_1.default.domainGreen900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.domainGreen800,
                hover: static_colors_1.default.domainGreen700,
                pressed: static_colors_1.default.domainGreen600,
                selected: static_colors_1.default.domainGreen600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        warning: {
            heavy: {
                default: static_colors_1.default.canary100,
                hover: static_colors_1.default.canary50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.canary300,
                hover: static_colors_1.default.canary200,
                pressed: static_colors_1.default.canary100,
                selected: static_colors_1.default.canary100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.canary400,
                hover: static_colors_1.default.canary300,
                pressed: static_colors_1.default.canary200,
                selected: static_colors_1.default.canary200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.canary700,
                hover: static_colors_1.default.canary600,
                pressed: static_colors_1.default.canary500,
                selected: static_colors_1.default.canary500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.canary900,
                hover: static_colors_1.default.canary900,
                pressed: static_colors_1.default.canary900,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.canary800,
                hover: static_colors_1.default.canary700,
                pressed: static_colors_1.default.canary600,
                selected: static_colors_1.default.canary600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        critical: {
            heavy: {
                default: static_colors_1.default.lobster100,
                hover: static_colors_1.default.lobster50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.lobster300,
                hover: static_colors_1.default.lobster200,
                pressed: static_colors_1.default.lobster100,
                selected: static_colors_1.default.lobster100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.lobster400,
                hover: static_colors_1.default.lobster300,
                pressed: static_colors_1.default.lobster200,
                selected: static_colors_1.default.lobster200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.lobster700,
                hover: static_colors_1.default.lobster600,
                pressed: static_colors_1.default.lobster500,
                selected: static_colors_1.default.lobster500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.lobster900,
                hover: static_colors_1.default.lobster900,
                pressed: static_colors_1.default.lobster900,
                selected: static_colors_1.default.lobster900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.lobster800,
                hover: static_colors_1.default.lobster700,
                pressed: static_colors_1.default.lobster600,
                selected: static_colors_1.default.lobster600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        accentOne: {
            heavy: {
                default: static_colors_1.default.blurple100,
                hover: static_colors_1.default.blurple50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.blurple300,
                hover: static_colors_1.default.blurple200,
                pressed: static_colors_1.default.blurple100,
                selected: static_colors_1.default.blurple100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.blurple400,
                hover: static_colors_1.default.blurple300,
                pressed: static_colors_1.default.blurple200,
                selected: static_colors_1.default.blurple200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.blurple700,
                hover: static_colors_1.default.blurple600,
                pressed: static_colors_1.default.blurple500,
                selected: static_colors_1.default.blurple500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.blurple900,
                hover: static_colors_1.default.blurple900,
                pressed: static_colors_1.default.blurple900,
                selected: static_colors_1.default.blurple900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.blurple800,
                hover: static_colors_1.default.blurple700,
                pressed: static_colors_1.default.blurple600,
                selected: static_colors_1.default.blurple600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        accentTwo: {
            heavy: {
                default: static_colors_1.default.aqua100,
                hover: static_colors_1.default.aqua50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.aqua300,
                hover: static_colors_1.default.aqua200,
                pressed: static_colors_1.default.aqua100,
                selected: static_colors_1.default.aqua100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.aqua400,
                hover: static_colors_1.default.aqua300,
                pressed: static_colors_1.default.aqua200,
                selected: static_colors_1.default.aqua200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.aqua700,
                hover: static_colors_1.default.aqua600,
                pressed: static_colors_1.default.aqua500,
                selected: static_colors_1.default.aqua500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.aqua900,
                hover: static_colors_1.default.aqua900,
                pressed: static_colors_1.default.aqua900,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.aqua800,
                hover: static_colors_1.default.aqua700,
                pressed: static_colors_1.default.aqua600,
                selected: static_colors_1.default.aqua600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        accentThree: {
            heavy: {
                default: static_colors_1.default.ocean100,
                hover: static_colors_1.default.ocean50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.ocean300,
                hover: static_colors_1.default.ocean200,
                pressed: static_colors_1.default.ocean100,
                selected: static_colors_1.default.ocean100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.ocean400,
                hover: static_colors_1.default.ocean300,
                pressed: static_colors_1.default.ocean200,
                selected: static_colors_1.default.ocean200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.ocean700,
                hover: static_colors_1.default.ocean600,
                pressed: static_colors_1.default.ocean500,
                selected: static_colors_1.default.ocean500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.ocean900,
                hover: static_colors_1.default.ocean900,
                pressed: static_colors_1.default.ocean900,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.ocean800,
                hover: static_colors_1.default.ocean700,
                pressed: static_colors_1.default.ocean600,
                selected: static_colors_1.default.ocean600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        accentFour: {
            heavy: {
                default: static_colors_1.default.canary100,
                hover: static_colors_1.default.canary50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.canary300,
                hover: static_colors_1.default.canary200,
                pressed: static_colors_1.default.canary100,
                selected: static_colors_1.default.canary100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.canary400,
                hover: static_colors_1.default.canary300,
                pressed: static_colors_1.default.canary200,
                selected: static_colors_1.default.canary200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.canary700,
                hover: static_colors_1.default.canary600,
                pressed: static_colors_1.default.canary500,
                selected: static_colors_1.default.canary500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.canary900,
                hover: static_colors_1.default.canary900,
                pressed: static_colors_1.default.canary900,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.canary800,
                hover: static_colors_1.default.canary700,
                pressed: static_colors_1.default.canary600,
                selected: static_colors_1.default.canary600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
        accentFive: {
            heavy: {
                default: static_colors_1.default.lobster100,
                hover: static_colors_1.default.lobster50,
                pressed: static_colors_1.default.white,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.coolGrey600,
            },
            medium: {
                default: static_colors_1.default.lobster300,
                hover: static_colors_1.default.lobster200,
                pressed: static_colors_1.default.lobster100,
                selected: static_colors_1.default.lobster100,
                disabled: static_colors_1.default.coolGrey700,
            },
            base: {
                default: static_colors_1.default.lobster400,
                hover: static_colors_1.default.lobster300,
                pressed: static_colors_1.default.lobster200,
                selected: static_colors_1.default.lobster200,
                disabled: static_colors_1.default.coolGrey600,
            },
            trim: {
                default: static_colors_1.default.lobster700,
                hover: static_colors_1.default.lobster600,
                pressed: static_colors_1.default.lobster500,
                selected: static_colors_1.default.lobster500,
                disabled: static_colors_1.default.coolGrey800,
            },
            subdued: {
                default: static_colors_1.default.lobster900,
                hover: static_colors_1.default.lobster900,
                pressed: static_colors_1.default.lobster900,
                selected: static_colors_1.default.lobster900,
                disabled: static_colors_1.default.coolGrey900,
            },
            surface: {
                default: static_colors_1.default.lobster800,
                hover: static_colors_1.default.lobster700,
                pressed: static_colors_1.default.lobster600,
                selected: static_colors_1.default.lobster600,
                disabled: static_colors_1.default.coolGrey900,
            },
        },
    },
};
exports.default = output;
//# sourceMappingURL=domain-2020-dark.js.map